import { removeFavoriteApi } from '@/entities/favorites';

import {
  clearPendingFavoriteRemovals,
  readPendingFavoriteRemoveIds,
} from './pendingRemoval';
import { useFavoriteGuestStore } from '../model/favoriteGuestStore';
import { useFavoritePendingUiStore } from '../model/favoritePendingUiStore';

export async function flushPendingFavoriteRemovals(): Promise<void> {
  const pending = readPendingFavoriteRemoveIds();
  if (!pending.length) {
    return;
  }

  const { removeById } = useFavoriteGuestStore.getState();

  for (const id of pending) {
    try {
      await removeFavoriteApi(id);
    } catch {
      /* гость или сеть — всё равно убираем из локального списка */
    }
    removeById(id);
  }

  clearPendingFavoriteRemovals();
  useFavoritePendingUiStore.getState().refresh();
}
